import { ThunkAction } from 'redux-thunk';
import { AnyAction } from 'redux';

import {
  RECEIVE_VISUAL_SEARCH_FAILURE,
  RECEIVE_VISUAL_SEARCH_INPUT_IMAGE,
  RECEIVE_VISUAL_SEARCH_SUCCESS,
  REQUEST_VISUAL_SEARCH,
  RESET_VISUAL_SEARCH_INPUT_IMAGE,
  RESET_VISUAL_SEARCH_RESULTS
} from 'constants/reduxActions';
import { AppState } from 'types/app';
import { ProductWithRelationsFromCalypso } from 'types/calypso';
import { fetchErrorMiddleware } from 'middleware/fetchErrorMiddleware';
import { fetchProductDetailsByStyleIds } from 'apis/calypso';
import { trackError } from 'helpers/ErrorUtils';

export function requestVisualSearch() {
  return {
    type: REQUEST_VISUAL_SEARCH
  } as const;
}

export function receiveVisualSearchSuccess(products: ProductWithRelationsFromCalypso[]) {
  return {
    type: RECEIVE_VISUAL_SEARCH_SUCCESS,
    products
  } as const;
}

export function receiveVisualSearchFailure() {
  return {
    type: RECEIVE_VISUAL_SEARCH_FAILURE
  } as const;
}

export function resetVisualSearchResults() {
  return {
    type: RESET_VISUAL_SEARCH_RESULTS
  } as const;
}

export function receiveVisualSearchInputImage(inputImage: File) {
  return {
    type: RECEIVE_VISUAL_SEARCH_INPUT_IMAGE,
    inputImage
  } as const;
}

export function resetVisualSearchInputImage() {
  return {
    type: RESET_VISUAL_SEARCH_INPUT_IMAGE
  } as const;
}

export function getProductsForStyleIds(styleIds: string[]): ThunkAction<Promise<void>, AppState, void, AnyAction> {
  return async (dispatch, getState) => {
    const {
      environmentConfig: {
        api: {
          calypso: { url, siteId, subsiteId }
        }
      }
    } = getState();

    const getProductDetails = async () => {
      dispatch(resetVisualSearchResults());
      dispatch(requestVisualSearch());
      const response: { results: ProductWithRelationsFromCalypso[] } = await fetchErrorMiddleware(
        (await fetchProductDetailsByStyleIds({ url, siteId, subsiteId }, styleIds)) as Response
      );
      dispatch(receiveVisualSearchSuccess(response.results));
    };

    return getProductDetails().catch(e => {
      trackError('NON-FATAL', 'Could not get Product details from StyleIds', e);
    });
  };
}

export type VisualSearchAction =
  | ReturnType<typeof requestVisualSearch>
  | ReturnType<typeof receiveVisualSearchSuccess>
  | ReturnType<typeof receiveVisualSearchFailure>
  | ReturnType<typeof resetVisualSearchResults>
  | ReturnType<typeof receiveVisualSearchInputImage>
  | ReturnType<typeof resetVisualSearchInputImage>;
